import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'masquerCarte',
  standalone: false,
})
export class MasquerCartePipe implements PipeTransform {
  transform(numeroCarte: string): string {
    return numeroCarte ? `**** **** **** ${numeroCarte.substring(12, 16)}` : '';
  }
}
